import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MailService } from '../../shared/services/mail/mail.service';
import { UiService } from '../../shared/services/ui/ui.service';

@Component({
  selector: 'app-confirm-mail',
  templateUrl: './confirm-mail.component.html',
  styleUrls: ['./confirm-mail.component.scss']
})
export class ConfirmMailComponent implements OnInit {

  isSuccessful = true;
  token = '';
  username = '';
  userId = '';
  exp = '';

  constructor(
    private uiService: UiService,
    private mailService: MailService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.initPage();
  }

  private initPage(): void {
    this.uiService.changeTitle('RamDam - Email');
    this.userId = this.route.snapshot.queryParamMap.get('id') || '';

    this.mailService.activateUser(this.userId).subscribe({
      next: () => {
        this.isSuccessful = true;
      },
      error: () => {
        this.isSuccessful = false;
      }
    })
  }
}
